import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { formatApiError } from "../lib/format";

const KINDS = ["Tarefa","Ligação","Documento","Processo","Reunião","Outro"];

export default function TaskDialog({ open, onClose, onSaved }) {
  const [form, setForm] = useState({ title:"", client_id:"", due_date:"", kind:"Tarefa", description:"" });
  const [clients, setClients] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      const today = new Date(); today.setDate(today.getDate()+1);
      setForm({ title:"", client_id:"", due_date: today.toISOString().slice(0,10), kind:"Tarefa", description:"" });
      api.get("/clients").then(r => setClients(r.data)).catch(()=>{});
    }
  }, [open]);
  if (!open) return null;

  const save = async () => {
    if (!form.title.trim() || !form.due_date) { toast.error("Preencha título e data"); return; }
    setBusy(true);
    try {
      await api.post("/tasks", { ...form, client_id: form.client_id || null });
      toast.success("Tarefa criada");
      onSaved?.(); onClose();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" data-testid="task-modal" onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} data-testid="close-task-modal"><span aria-hidden>×</span></button>
        <span className="eyebrow">NOVA TAREFA</span>
        <h2>Adicionar à agenda</h2>
        <p>Não perca prazos importantes.</p>
        <label>Título<input data-testid="task-title-input" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Ex.: Conferir documentos"/></label>
        <label>Cliente
          <select data-testid="task-client-select" value={form.client_id} onChange={e=>setForm({...form,client_id:e.target.value})}>
            <option value="">— sem cliente —</option>
            {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </label>
        <label>Data<input data-testid="task-date-input" type="date" value={form.due_date} onChange={e=>setForm({...form,due_date:e.target.value})}/></label>
        <label>Tipo
          <select data-testid="task-kind-select" value={form.kind} onChange={e=>setForm({...form,kind:e.target.value})}>
            {KINDS.map(k=><option key={k}>{k}</option>)}
          </select>
        </label>
        <label>Descrição<textarea data-testid="task-description-input" rows={2} value={form.description} onChange={e=>setForm({...form,description:e.target.value})}/></label>
        <button data-testid="save-task-button" className="primary-button full" disabled={busy} onClick={save}>
          <CheckCircle2 size={16}/> {busy?"Salvando...":"Salvar tarefa"}
        </button>
      </div>
    </div>
  );
}
